import { find, first, get, reject, size, some } from "lodash";
import { Timezone } from "@linkfluence/models/timezone";
import { useProjectWorkspaces } from "@radarly/core/project/use-cases";
import {
  useCurrentUser,
  useCurrentUserProjects,
  useCurrentUserTimezone,
} from "@radarly/core/user/use-cases";
import { useSearchWorkspaces } from "@radarly/core/workspace/use-cases";
import { Project } from "@radarly/models/project";
import { SearchableWorkspace, Workspace } from "@radarly/models/workspace";
import { IRouterService } from "@radarly/shared/router";
import { Page } from "@radarly/shared/router/pages";

export function getLandingUrl(
  router: IRouterService,
  targetPage: Page,
  currentProject: Project,
  currentWorkspaces: Workspace[],
  searchableWorkspaces: SearchableWorkspace[],
  projects: Project[],
  timezone: Timezone
) {
  const userProjects = reject(
    projects,
    (project) => !get(project, "flags.isActive", false)
  );
  if (
    currentProject &&
    some(userProjects, { id: currentProject.id }) &&
    size(currentWorkspaces)
  ) {
    const firstCurrentWorkspace = first(currentWorkspaces);
    return router.getWorkspaceUrlFromPage(
      targetPage,
      currentProject,
      firstCurrentWorkspace.id,
      { timezone }
    );
  } else if (size(searchableWorkspaces)) {
    const firstSearchableWorkspace = first(searchableWorkspaces);
    return router.getWorkspaceUrlFromPage(
      targetPage,
      firstSearchableWorkspace.project,
      firstSearchableWorkspace.id,
      { timezone }
    );
  } else {
    //no workspaces available, check if the user can access at least one project

    if (userProjects.length) {
      //redirect to first project home
      return router.getProjectUrlFromPage(
        first(userProjects),
        Page.projectHome
      );
    } else {
      //redirect to no project error page
      return router.getPathFromPage(Page.noProject);
    }
  }
}

export function useLandingRedirection(router: IRouterService) {
  const { workspaces, loading } = useSearchWorkspaces("");
  const projects = useCurrentUserProjects();
  const timezone = useCurrentUserTimezone();
  const currentProjectId = get(useCurrentUser(), "currentProjectId", 0);
  const { workspaces: currentProjectWorkspaces, loading: projectDashLoading } =
    useProjectWorkspaces(currentProjectId);
  const isFetching = loading || projectDashLoading;
  return {
    loading: isFetching,
    url: isFetching
      ? ""
      : router.getLandingPage(
          find(projects, { id: currentProjectId }),
          currentProjectWorkspaces,
          workspaces,
          projects,
          timezone
        ),
  };
}
